import React from 'react';
import { Button } from '@chakra-ui/react';
import { House, X } from '@phosphor-icons/react';

const NoDropPointFilterButton = ({ refetch, dispatch, state }) => {
  const handleShowNoDropPoints = async () => {
    // await refetch({
    //   where: {
    //     ...state.searchValues,
    //     packageStations_some: {
    //       isOnboarded: false,
    //     },
    //   },
    // });
    dispatch({ type: 'SET_NO_DROPPOINT', value: true });
  };
  const handleHideNoDropPoints = async () => {
    // await refetch({
    //   where: {
    //     ...state.searchValues,
    //     packageStations_some: {
    //       isOnboarded: undefined,
    //     },
    //   },
    // });
    dispatch({ type: 'SET_NO_DROPPOINT', value: false });
  };

  return (
    <Button
      leftIcon={state.noDropPointIsActive ? <X /> : <House />}
      onClick={state.noDropPointIsActive ? handleHideNoDropPoints : handleShowNoDropPoints}
      size="sm"
      mb="2"
      mr="2"
    >
      Kein DropPoint
    </Button>
  );
};

export default NoDropPointFilterButton;
